import {Button, Modal} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {Formik, Form} from "formik";
import {addPhieuKeHoach, updatePhieuKeHoach} from "../services/services";
import {CODE, TYPE_WH} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import CustomTabMenu from "../../../../component/CustomTabMenu";
import {EnterReasonDialog} from "../../../../component/EnterReasonDialog";
import {cancelApproval} from "../../../../phan-he-xuat-kho/services/servicesXuatKho";
import {XayDungKeHoachContext} from "../XayDungKeHoach";
import TableDangKyDaoTao from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/components/TableDangKyDaoTao";
import {TYPE_QL_DAO_TAO} from "../constants/constansKeHoach";
import DialogSelectList from "./DialogSelectList";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

const DialogKeHoachDaoTao = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(!!detailPhieuKeHoach.id || detailPhieuKeHoach?.isView);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [itemSelected, setItemSelected] = useState<any>();
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [dataTable, setDataTable] = useState<any>({
    dataGiangVien: []
  });

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      slipDto: {
        ...initialValuesFormThemVT,
        type: TYPE_WH.IMPORT,
        doCreation: values?.keHoach?.id ? formatDateDTO(values?.keHoach?.doCreation) : formatDateDTO(new Date()),
      },
      trackerCode: type.trackerCode,
      termModelType: type?.formVatTu,
    };

    try {
      setIsLoading(true);
      const id = values.keHoach?.id;
      const {data} = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        setInitialValues && setInitialValues(data?.data);
        setDetailPhieuKeHoach({
          ...data?.data,
          statusId: detailPhieuKeHoach.statusId,
        });
        toast.success(((id) ? "Cập nhật" : "Thêm") + " kế hoạch thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (initialValues?.keHoach?.id) {
      setDataTable({
        [TYPE_QL_DAO_TAO.KHDT.formVatTu]: [
          {
            content: "GV001", // Mã giảng viên
            receivingHospitalName: "Nguyễn Văn A", // Tên giảng viên
            birthYear: 1985,
            gender: "Nam",
            address: "123 Lê Lợi, Q1, TP.HCM",
            phone: "0901234567",
            email: "nguyenvana@example.com",
            department: "Khoa CNTT",
          },
          {
            content: "GV002",
            receivingHospitalName: "Trần Thị B",
            birthYear: 1990,
            gender: "Nữ",
            address: "456 Nguyễn Trãi, Q5, TP.HCM",
            phone: "0912345678",
            email: "tranthib@example.com",
            department: "Khoa Y tế công cộng",
          },
          {
            content: "GV003",
            receivingHospitalName: "Lê Minh C",
            birthYear: 1988,
            gender: "Nam",
            address: "789 Võ Văn Kiệt, Q6, TP.HCM",
            phone: "0987654321",
            email: "leminhc@example.com",
            department: "Khoa Xã hội học",
          },
        ]
      })
    }
    initialValues?.keHoach?.id && setDsKeHoach(initialValues?.keHoach?.listOfInstructions);
  }, [initialValues?.keHoach?.id]);

  useEffect(() => {
    updateFormVatTu();
  }, []);

  const updateFormVatTu = async () => {
    const data = await generateForm(type.formVatTu, setIsLoading);
    setListJsonGenerateVT(data || []);
    setInitialValuesFormThemVT({...generateInitValues(data), ...(initialValues?.keHoach ?? {})});
  };
  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  const handleEdit = (rowData: any, index: number) => {
    setItemSelected(rowData);
    setIndexRowEdit(index);
    setOpenDialogThemMoi(true)
  }

  const handleOpenDialogAddNew = (type?: any) => {
    setOpenDialogThemMoi(true);
  }

  const hanldeDeleteRow = (index: number, typeDelete: any) => {
    const key = typeDelete?.formVatTu;
    const list = dataTable?.[key] || [];

    const newList = list.filter((x: any, i: number) => i !== index);
    setDataTable((pre: any) => ({...pre, [key]: newList}));
  }

  const handleAddItem = async (values: any, source?: string) => {
    const dataItem = values?.[TYPE_QL_DAO_TAO.KHDT.formVatTu] || {};

    let newLstItem = source ? [...dataTable?.[source], dataItem] : [...dataItem];
    if (indexRowEdit === null) {
      newLstItem = [...newLstItem, {...dataItem}];
    } else {
      newLstItem[indexRowEdit] = {...dataItem};
    }

    if (source) {
      setDataTable((pre: any) => ({...pre, [source]: newLstItem}));
    } else {
      setDataTable((pre: any) => ({...pre, newLstItem}));
    }
  };

  const handleCloseDialog = () => {
    setItemSelected(null);
    setIndexRowEdit(null);
    setOpenDialogThemMoi(false);
  };


  const handleApproveReq = async (values?: any) => { // nhập lý do từ chối duyệt
    try {
      setIsLoading(true);
      const {data} = await cancelApproval(values, initialValues.id);
      if (CODE.SUCCESS === data.code) {
        detailPhieuKeHoach.submit && detailPhieuKeHoach.submit();
        handleCloseDialog();
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại')
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const columnsDkDaoTao = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                {/*<i*/}
                {/*    onClick={(e) => handleEdit(row, index)}*/}
                {/*    className="bi bi-pencil-square text-navy"*/}
                {/*></i>*/}
                  <i
                      onClick={(e) => hanldeDeleteRow(index, TYPE_QL_DAO_TAO.KHDT)}
                      className="bi bi-trash3-fill text-danger spaces ml-10  "
                  ></i>
              </>}
            </div>
        },
      ] : []),

    {
      name: "Mã giảng viên",
      field: "content",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.content || row.item?.content || '',
    },
    {
      name: "Tên giảng viên",
      field: "receivingHospital",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.receivingHospitalName || row.item?.receivingHospitalName || '',
    },
    {
      name: "Năm sinh",
      field: "birthYear",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.birthYear || row.item?.birthYear || '',
    },
    {
      name: "Giới tính",
      field: "gender",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.gender || row.item?.gender || '',
    },
    {
      name: "Địa chỉ",
      field: "address",
      headerStyle: {
        minWidth: 220,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.address || row.item?.address || '',
    },
    {
      name: "Điện thoại",
      field: "phone",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.phone || row.item?.phone || '',
    },
    {
      name: "Email",
      field: "email",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.email || row.item?.email || '',
    },
    {
      name: "Tên phòng ban",
      field: "department",
      headerStyle: {
        minWidth: 220,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.department || row.item?.department || '',
    },
  ];
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-phieu-khao-sat"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{keHoach: initialValuesFormThemVT}}
        validationSchema={generateValidationSchema(listJsonGenerateVT, 'keHoach')}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Thiết lập khóa học`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <CustomTabMenu
                  danhsachTabs={[
                    {
                      eventKey: "TTC",
                      title: "Thông tin chung",
                      component: <>
                        <div className="spaces px-10">
                          <GenerateFormComponent
                            isView={isView}
                            listFieldAuto={listJsonGenerateVT}
                            handleChange={handleChange}
                            setValues={setValues}
                            values={values}
                            touched={touched}
                            errors={errors}
                            propsRenderButton={handler}
                            lstSelectedRenderButton={dsKeHoach}
                            setFieldValue={setFieldValue}
                            modelID={"keHoach"}
                            customComponent={DynamicComponent}
                            warehouseId={warehouseId}
                          />
                        </div>
                        <TableDangKyDaoTao
                          title={"Thông tin giảng viên"}
                          columns={columnsDkDaoTao}
                          isView={isView}
                          setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                          setOpenDialog={handleOpenDialogAddNew}
                          dsItems={dataTable?.[TYPE_QL_DAO_TAO.KHDT.formVatTu] ?? []} type={undefined}/>
                      </>,
                    },
                    {
                      eventKey: "TLDK",
                      title: "Tài liệu đính kèm",
                      component: "Tài liệu đính kèm",
                    },
                  ]}
                  className="spaces pl-0"
                />
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...data,
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    handleClick={(data: any) => {
                      data.code === "allowed-edit" && setIsView(false);
                    }}
                    tracker={type.trackerCode}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                  />
                )}
              </div>
            </Form>
            {openDialogThemMoi &&
                <DialogSelectList
                    title={"Thêm mới giảng viên"}
                    titleList={"Danh sách giảng viên"}
                    onOk={handleAddItem}
                    show={openDialogThemMoi}
                    onHide={handleCloseDialog}
                    initialValues={{
                      [TYPE_QL_DAO_TAO.KHDT.formVatTu]: {
                        ...itemSelected,
                      }
                    }}
                    type={TYPE_QL_DAO_TAO.KHDT}
                />
            }
            {
              detailPhieuKeHoach?.componentName === "DialogEnterReason" &&
                <EnterReasonDialog
                    labelReason={"Lý do yêu cầu chỉnh sửa"}
                    show={detailPhieuKeHoach?.componentName === "DialogEnterReason"}
                    title={`Yêu cầu chỉnh sửa`}
                    onHide={handleCloseDialog}
                    onSubmit={handleApproveReq}
                />
            }
            {
              detailPhieuKeHoach?.componentName === "DialogEnterReason" &&
                <EnterReasonDialog
                    labelReason={"Lý do"}
                    show={detailPhieuKeHoach?.componentName === "DialogEnterReason"}
                    title={`Từ chối`}
                    onHide={handleCloseDialog}
                    onSubmit={handleApproveReq}
                />
            }
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogKeHoachDaoTao;
